export interface JsonContractComment {
  id: string;
  contractId: number;
  body: string;
  bactif: number;
  author: string;

  editedBy?: string | null;

  editedAt?: {
    date: string;
    timezone_type: number;
    timezone: string;
  } | null;

  type?: number | null;

  commentDate?: {
    date: string;
    timezone_type: number;
    timezone: string;
  } | null;
}

export class ContractComment {
  id: string;
  contractId: number;
  body: string;
  bactif: number;
  author: string;

  editedBy?: string | null;
  type?: number | null;

  commentDate: Date | null;
  editedAt?: Date | null;

  constructor(jsonContractComment: JsonContractComment = null) {
    if (jsonContractComment) {
      this.id = jsonContractComment.id;
      this.contractId = jsonContractComment.contractId;
      this.body = jsonContractComment.body;
      this.bactif = jsonContractComment.bactif;
      this.author = jsonContractComment.author;

      this.editedBy = jsonContractComment.editedBy ?? null;
      this.type = jsonContractComment.type ?? null;

      if (jsonContractComment.commentDate && jsonContractComment.commentDate.date) {
        const formattedDate = jsonContractComment.commentDate.date.replace(' ', 'T') + 'Z';
        this.commentDate = new Date(formattedDate);
      } else {
        this.commentDate = null;
      }

      if (jsonContractComment.editedAt && jsonContractComment.editedAt.date) {
        const formattedEditedAt = jsonContractComment.editedAt.date.replace(' ', 'T') + 'Z';
        this.editedAt = new Date(formattedEditedAt);
      } else {
        this.editedAt = null;
      }
    } else {
      this.commentDate = null;
      this.editedAt = null;
    }
  }
}
